// Undo/Redo stack — maksimal 25 langkah
export function createUndoStack(limit = 25) {
  let past = [];
  let future = [];

  return {
    push(state) {
      past.push(JSON.parse(JSON.stringify(state)));
      if (past.length > limit) past.shift();
      future = [];
    },
    undo(current) {
      if (past.length === 0) return null;
      future.push(JSON.parse(JSON.stringify(current)));
      return past.pop();
    },
    redo(current) {
      if (future.length === 0) return null;
      past.push(JSON.parse(JSON.stringify(current)));
      return future.pop();
    },
    canUndo: () => past.length > 0,
    canRedo: () => future.length > 0,
    clear() { past = []; future = []; }
  };
}
